import React, { useEffect, useState, useRef, createElement } from 'react';
import { CheckCircle2 } from 'lucide-react';
function CountdownTimer() {
  const [seconds, setSeconds] = useState(5 * 60 + 59);
  useEffect(() => {
    if (seconds <= 0) return;
    const interval = setInterval(() => setSeconds(s => s - 1), 1000);
    return () => clearInterval(interval);
  }, [seconds]);
  const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
  const secs = (seconds % 60).toString().padStart(2, '0');
  return <span className="font-mono font-bold text-white text-xs md:text-base tracking-wider" data-id="element-807">
      {mins}:{secs}
    </span>;
}
declare global {
  interface Window {
    checkoutElements: any;
  }
}
function HotmartSalesFunnel() {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const scriptId = 'hotmart-checkout-elements-up2';
    const mount = () => {
      if (window.checkoutElements && containerRef.current) {
        containerRef.current.innerHTML = '';
        window.checkoutElements.init('salesFunnel').mount(containerRef.current);
      }
    };
    if (document.getElementById(scriptId)) {
      mount();
      return;
    }
    const existingScript = document.querySelector('script[src="https://checkout.hotmart.com/lib/hotmart-checkout-elements.js"]');
    if (existingScript) {
      mount();
      return;
    }
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://checkout.hotmart.com/lib/hotmart-checkout-elements.js';
    script.async = true;
    script.onload = mount;
    document.head.appendChild(script);
  }, []);
  return <div ref={containerRef} id="hotmart-sales-funnel-up2" data-id="element-808"></div>;
}
export function UpsellPage2() {
  return <div className="min-h-screen bg-brand-bg flex flex-col" data-id="element-809">
      {/* Top Urgency Banner */}
      <div className="bg-brand-gold text-brand-bg text-center py-1.5 px-3 relative shrink-0" data-id="element-810">
        <p className="font-bold text-[11px] md:text-sm relative z-10 leading-tight" data-id="element-811">
          ¡UN PASO MÁS! Completa tu Arsenal Financiero y Ahorra 60%
        </p>
        <div className="flex items-center justify-center gap-1.5 relative z-10" data-id="element-812">
          <span className="text-brand-bg/70 text-[9px] md:text-xs" data-id="element-813">
            Esta oferta desaparece cuando cierres esta página:
          </span>
          <CountdownTimer data-id="element-814" />
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex items-start justify-center px-2.5 md:px-6 py-4 md:py-8" data-id="element-815">
        <div className="w-full max-w-3xl bg-brand-card border border-brand-gold/15 rounded-xl overflow-hidden shadow-2xl shadow-black/30" data-id="element-816">
          {/* Product Section */}
          <div className="p-3 md:p-6" data-id="element-817">
            <div className="flex flex-row gap-3 md:gap-6 items-start" data-id="element-818">
              {/* Product Image */}
              <div className="shrink-0 w-[100px] md:w-[200px]" data-id="element-819">
                <img src="https://cdn.magicpatterns.com/uploads/6zEPisftcL2DrVpJ9hhyuQ/Indice_Activos_Tangibles_Cover.png" alt="El Índice de Activos Tangibles" className="w-full rounded-lg shadow-lg border border-brand-gold/10" data-id="element-820" />
              </div>

              {/* Title + Price */}
              <div className="flex-1 space-y-1.5 md:space-y-3" data-id="element-821">
                <h1 className="text-sm md:text-xl font-bold text-white font-serif leading-tight" data-id="element-822">
                  El Índice de Activos Tangibles
                </h1>

                <div className="flex items-center gap-2 flex-wrap" data-id="element-823">
                  <span className="text-brand-muted line-through text-xs md:text-base" data-id="element-824">
                    $47.00
                  </span>
                  <span className="text-brand-gold font-bold text-lg md:text-2xl" data-id="element-825">
                    $19.00
                  </span>
                  <span className="bg-brand-green/20 text-brand-green text-[9px] md:text-xs font-bold px-1.5 py-0.5 rounded border border-brand-green/30" data-id="element-826">
                    60% OFF
                  </span>
                </div>
              </div>
            </div>

            {/* Copy */}
            <div className="space-y-2.5 md:space-y-3 text-brand-text/85 text-xs md:text-sm leading-relaxed mt-3 mb-3" data-id="element-827">
              <p className="text-white font-bold text-sm md:text-base" data-id="element-828">
                Ya dijiste SÍ una vez... ¿Por qué detenerte cuando estás a UN
                CLICK de blindar COMPLETAMENTE tu patrimonio?
              </p>
              <p data-id="element-829">
                Acabas de tomar una decisión{' '}
                <strong className="text-white" data-id="element-830">INTELIGENTE</strong>.
              </p>
              <p data-id="element-831">Pero déjame ser honesto contigo...</p>
              <p data-id="element-832">
                El 87% de las personas que adquieren solo el primer producto se
                arrepienten de no haber aprovechado esta oferta cuando tuvieron
                la oportunidad.
              </p>
              <p data-id="element-833">¿Por qué?</p>
              <p data-id="element-834">
                Porque{' '}
                <strong className="text-white" data-id="element-835">
                  "El Índice de Activos Tangibles"
                </strong>{' '}
                es la pieza que faltaba para COMPLETAR tu sistema de protección
                financiera.
              </p>
              <p className="font-semibold text-white" data-id="element-836">Piensa en esto:</p>

              {/* Green checks */}
              <div className="space-y-1.5" data-id="element-837">
                <div className="flex items-start gap-1.5" data-id="element-838">
                  <CheckCircle2 className="w-3.5 h-3.5 text-brand-green shrink-0 mt-px" data-id="element-839" />
                  <span className="text-brand-text/90" data-id="element-840">
                    Ya invertiste en el blindaje
                  </span>
                </div>
                <div className="flex items-start gap-1.5" data-id="element-841">
                  <CheckCircle2 className="w-3.5 h-3.5 text-brand-green shrink-0 mt-px" data-id="element-842" />
                  <span className="text-brand-text/90" data-id="element-843">
                    Ya confiaste en nosotros
                  </span>
                </div>
                <div className="flex items-start gap-1.5" data-id="element-844">
                  <CheckCircle2 className="w-3.5 h-3.5 text-brand-green shrink-0 mt-px" data-id="element-845" />
                  <span className="text-brand-text/90" data-id="element-846">
                    Ya diste el primer paso
                  </span>
                </div>
              </div>

              <p className="text-white font-bold" data-id="element-847">
                ¿Vas a dejar tu sistema INCOMPLETO por solo $19.00?
              </p>

              {/* Urgency block */}
              <div className="bg-brand-red/10 border border-brand-red/20 rounded-lg p-3 mt-1" data-id="element-848">
                <p className="text-white font-bold text-xs md:text-sm mb-2" data-id="element-849">
                  🚨 AQUÍ ESTÁ LO QUE PIERDES SI CIERRAS ESTA PÁGINA:
                </p>
                <div className="space-y-1.5" data-id="element-850">
                  <p className="text-brand-text/85" data-id="element-851">
                    ❌ Este precio de $19.00 (normalmente $47) NUNCA volverá a
                    estar disponible
                  </p>
                  <p className="text-brand-text/85" data-id="element-852">
                    ❌ Esta oferta desaparece en menos de 5 minutos
                  </p>
                  <p className="text-brand-text/85" data-id="element-853">
                    ❌ Si vuelves mañana, pagarás el DOBLE (si es que aún está
                    disponible)
                  </p>
                  <p className="text-brand-text/85" data-id="element-854">
                    ❌ Te quedarás con un capital expuesto sin saber dónde
                    moverlo
                  </p>
                  <p className="text-brand-text/85" data-id="element-855">
                    ❌ Te quedarás preguntándote "¿Y si hubiera dicho SÍ?"
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Order Summary */}
          <div className="border-t border-brand-gold/10 bg-brand-bg/50 px-4 md:px-6 py-2 md:py-3" data-id="element-856">
            <div className="max-w-xs ml-auto space-y-1" data-id="element-857">
              <div className="flex items-center justify-between text-[11px] md:text-sm" data-id="element-858">
                <span className="text-brand-muted" data-id="element-859">Subtotal</span>
                <span className="text-white font-medium" data-id="element-860">$19.00</span>
              </div>
              <div className="flex items-center justify-between text-[11px] md:text-sm" data-id="element-861">
                <span className="text-brand-muted" data-id="element-862">Impuestos</span>
                <span className="text-brand-muted" data-id="element-863">N/A</span>
              </div>
              <div className="border-t border-brand-gold/15 pt-1.5 flex items-center justify-between" data-id="element-864">
                <span className="text-white font-bold text-xs md:text-sm" data-id="element-865">
                  Total
                </span>
                <span className="text-white font-bold text-sm md:text-lg" data-id="element-866">
                  USD $19.00
                </span>
              </div>
            </div>
          </div>

          {/* Hotmart Sales Funnel Widget */}
          <div className="px-4 md:px-6 pb-3 pt-1" data-id="element-867">
            <HotmartSalesFunnel data-id="element-868" />
          </div>

          {/* Guarantee */}
          <p className="text-center text-brand-muted text-xs italic pb-4" data-id="element-869">
            100% Garantizado
          </p>
        </div>
      </div>
    </div>;
}